<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload //提供数据
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
        console.log("确实刷新了")
      })
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
}

.flex {
  display: flex;
}

.justify-content {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.fd {
  flex-direction: column;
}

.content-title {
  display: flex;
  align-items: center;
}

.content-title .title-line {
  width: 7px;
  height: 24px;
  background: #435696;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.content-title .title {
  font-size: 24px;
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 600;
  color: #000000;
  margin-left: 6px;
  line-height: 19px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;

  background-color: #bfbfbf;

}

::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue